<template>
  <v-dialog v-model="value" persistent width="500px">
    <v-card class="w-100 rounded-lg">
      <v-card-title style="word-break: break-word">
        {{ $t('spedilink.groups.deleteTitle') }}
      </v-card-title>
      <v-card-text class="text-subtitle-1 font-weight-regular">
        {{ $t('spedilink.groups.deleteMessage') }}
        <strong>{{ group.name }}</strong>?
        <div class="mt-2 grey--text text-body-2">
          {{ $t('spedilink.groups.deleteWarning') }}
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn outlined :disabled="loading" @click="close()">
          {{ $t('common.no') }}
        </v-btn>
        <v-btn
          color="primary"
          class="ma-2"
          :loading="loading"
          :disabled="loading"
          @click="remove()"
        >
          {{ $t('common.yes') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Service from '@/services'

export default {
  name: 'DeleteSpediLinkGroupDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    group: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async remove () {
      this.loading = true
      try {
        await Service.delete(`spedilink/SpediLinkGroups/Delete/${this.group.id}`)
        await this.$store.dispatch('setSuccessNotification', this.$t('common.confirmOperation'))
        this.$emit('group-deleted')
      } catch (e) {
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
